import { kAcceptedFilesList } from '@/constants/constants-gcs'

const acceptedExtensionsLower = new Set(
  Object.values(kAcceptedFilesList)
    .flat()
    .map((ext) => ext.toLowerCase())
)

/**
 * Whether a local `File` may be uploaded to user-files / Drive (matches `kAcceptedFilesList` / Files dropzone).
 * Extension is authoritative when present; MIME is a secondary signal for OS-provided types.
 */
export function isFileAcceptedForUserFilesUpload(file: File): boolean {
  // Determine based on extension
  const name = file.name
  const dot = name.lastIndexOf('.')
  if (dot >= 0 && dot < name.length - 1) {
    const ext = name.slice(dot).toLowerCase()
    if (acceptedExtensionsLower.has(ext)) return true
  }

  // Determine based on MIME type
  const type = file.type
  if (type && Object.hasOwn(kAcceptedFilesList, type)) return true
  return false
}
